<template>
  <div v-if="!data">
    <h3>{{ s_FilterChips_NoData }}</h3>
  </div>

  <v-card v-else style="height: 100%" class="box-container" align="start" justify="start" flat width="100%">
    <v-row class="row-header ma-0 pa-0" align="start" justify="start">
      <v-chip class="ma-1" v-for="(selection, i) in chosen" :key="i" close @click:close="removeChip(i)">
        <!-- <v-icon left v-text="selection.icon"></v-icon> -->
        <v-icon left></v-icon>
        {{ selection }}
      </v-chip>
    </v-row>
    <v-row class="row-header ma-0 pa-0">
      <v-text-field class="ma-0 py-5" style="width: 60%; min-width: 80px" :label="s_Search" v-model="searchString" @input="Search()"></v-text-field>
    </v-row>
    <div class="row-content-limited ma-0 pa-0">
      <v-row class="ma-0 pa-0" align="start" justify="start">
        <template v-for="(d, i) in filterData">
          <v-chip class="ma-1" :key="i" v-if="!chosen.includes(d)" outlined :value="chosen" @click="setChip(d)">
            {{ d }}
          </v-chip>
        </template>
      </v-row>
    </div>
    <!-- <v-chip-group column multiple :value="value" @change="setChip()">
      <v-row class="ma-0 pa-0" align="center">
        <v-chip filter outlined v-for="(d, i) in getData" :key="i">
          {{ d }}
        </v-chip></v-row
      ></v-chip-group
    > -->
  </v-card>
</template>

<script>
import { TR } from "../../../main";
export default {
  props: ["data", "value"],
  data() {
    return {
      searchString: "",
      filterData: null,
      chosen: [],
      s_Search: TR.Search,
      s_FilterChips_NoData: TR.FilterChips_NoData,
    };
  },
  computed: {},
  methods: {
    removeChip(i) {
      this.chosen.splice(i, 1);
      this.searchString = "";
      this.$emit("input", this.chosen);
      this.$emit("change", this.chosen);
    },
    setChip(data) {
      this.chosen.push(data);
      this.$emit("input", this.chosen);
      this.$emit("change", this.chosen);
    },
    Search() {
      this.filterData = this.data.filter((e) => e.toLowerCase().includes(this.searchString.toLowerCase()));
    },
  },
  mounted() {
    this.filterData = [...this.data];
    this.chosen = [...this.value];
  },
};
</script>

<style scoped></style>
